module.exports = __webpack_public_path__ + "img/bg.50204e67.jpeg";